import React from 'react';
import Header from '@/components/Header';
import MinimalFooter from '@/components/MinimalFooter';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Brain, Wand2, Moon, Lightbulb } from 'lucide-react';
import ScienceInfo from '@/components/ScienceInfo';
import { Separator } from "@/components/ui/separator";
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <div className="container mx-auto px-4 py-6 flex-grow">
        <section className="mb-8 animate-fade-in">
          <Card className="bg-card/50 border-primary/10">
            <CardHeader>
              <CardTitle className="text-2xl">About BinauralFlow</CardTitle>
              <CardDescription>
                Harness the power of binaural beats for focus, relaxation, and enhanced well-being.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                BinauralFlow is your personal sound therapy companion, designed to help you achieve
                specific mental states through the use of binaural beats. Whether you're looking to
                boost your focus, deepen your meditation practice, or simply unwind after a long day,
                BinauralFlow offers a curated selection of sound frequencies to guide you.
              </p>
            </CardContent>
          </Card>
        </section>

        <section className="mb-8 animate-fade-in animate-delay-100">
          <Card className="bg-card/50 border-primary/10">
            <CardHeader>
              <CardTitle>How It Works</CardTitle>
              <CardDescription>
                Understanding the science behind binaural beats
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ScienceInfo />
            </CardContent>
          </Card>
        </section>

        <section className="mb-8 animate-fade-in animate-delay-200">
          <Card className="bg-card/50 border-primary/10">
            <CardHeader>
              <CardTitle>Key Features</CardTitle>
              <CardDescription>
                Discover what makes BinauralFlow unique
              </CardDescription>
            </CardHeader>
            <CardContent className="grid gap-6">
              <div id="focus" className="flex items-start space-x-4">
                <div className="rounded-lg bg-primary/10 p-3">
                  <Wand2 className="h-6 w-6 text-primary" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium leading-none">Focus and Productivity</p>
                  <p className="text-sm text-muted-foreground">
                    Beta waves to enhance focus and mental clarity.
                  </p>
                </div>
              </div>

              <div id="meditation" className="flex items-start space-x-4">
                <div className="rounded-lg bg-primary/10 p-3">
                  <Moon className="h-6 w-6 text-primary" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium leading-none">Deep Meditation</p>
                  <p className="text-sm text-muted-foreground">
                    Theta waves to deepen your meditation practice.
                  </p>
                </div>
              </div>

              <div id="beta" className="flex items-start space-x-4">
                <div className="rounded-lg bg-primary/10 p-3">
                  <Lightbulb className="h-6 w-6 text-primary" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium leading-none">Focus and Productivity</p>
                  <p className="text-sm text-muted-foreground">
                    Beta waves to enhance focus and mental clarity.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </section>

        <section id="mission" className="mb-8 animate-fade-in animate-delay-300">
          <Card className="bg-card/50 border-primary/10">
            <CardHeader>
              <CardTitle>Our Mission</CardTitle>
              <CardDescription>
                Empowering minds through sound, making mental wellness accessible to everyone.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                At BinauralFlow, we believe in the power of sound to transform mental states. Our
                mission is to provide accessible, science-backed tools that help you take control of
                your mental well-being.
              </p>
            </CardContent>
          </Card>
        </section>
      </div>
      
      <MinimalFooter />
    </div>
  );
};

export default About;
